<template>
    <div class="dialog-wrap">
        <el-dialog
            v-model="visible"
            v-bind="$attrs"
            :close-on-click-modal="($attrs.closeOnClickModal as any) ?? false"
            :show-close="($attrs.showClose as any) ?? true"
            align-center
        >
            <template #header>
                {{ title }}
                <div v-if="subtitle" class="subtitle">
                    {{ subtitle }}
                </div>
            </template>
            <slot />
            <template #footer>
                <div class="dialog-footer">
                    <el-button v-if="!isNotShowCloseBtn" plain @click="onClose"> 取消 </el-button>
                    <el-button
                        v-if="!isNotShowSubmitBtn"
                        type="primary"
                        color="#1966FF"
                        :disabled="submitDisabled"
                        @click="onSubmit"
                    >
                        {{ submitText || "提交" }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup lang="ts">
export interface ZhDialogProps {
    title: string;
    subtitle?: string;
    submitText?: string;
    submitDisabled?: boolean;
    isNotShowSubmitBtn?: boolean;
    isNotShowCloseBtn?: boolean;
}

const props = defineProps<ZhDialogProps>();
const emits = defineEmits(["close", "submit"]);

const visible = defineModel<boolean>("modelValue", { default: false });

const onSubmit = async () => {
    emits("submit");
};

const onClose = () => {
    emits("close");
};
</script>

<style scoped lang="scss">
.dialog-wrap {
    position: absolute;
    :deep .el-dialog {
        padding: 0;

        .el-dialog__header {
            padding: 16px;
            border-bottom: 1px solid #d9d9d9;
            color: #000000;
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            .subtitle {
                color: #bfbfbf;
                font-size: 12px;
                line-height: 12px;
                margin-top: 6px;
            }
        }
        .el-dialog__body {
            padding: 16px;
        }
        .el-dialog__footer {
            padding: 16px;
            padding-top: 0;
        }
    }
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
